<div
  id="add-alert-bcc"
  class="bcc-renderer-container"
  role="button"
  tabindex="0"
  [attr.aria-expanded]="expanded"
  (mousedown)="onMouseDown($event)"
  (click)="onExpandClick($event)"
  (focusout)="onFocusOut()"
  [class.expanded]="expanded"
>
  <form [formGroup]="bccForm">
    <app-input-chips
      #bccChips
      placeHolder="Enter Bcc recipients..."
      [chips]="currentEditing"
      (chipsChange)="onChipsChange($event)"
      controlName="bccAlert"
      [separatorKeysCodes]="separatorKeysCodes"
      [maxVisibleRows]="maxVisibleRows"
      [forceShowAll]="expanded"
      [maxListHeight]="maxListHeight"
      [color]="'primary'"
    >
    </app-input-chips>
  </form>
</div>
